import { render } from "./Steps.vue?vue&type=template&id=baf6f7ee"
import script from "./Steps.vue?vue&type=script&lang=js"
export * from "./Steps.vue?vue&type=script&lang=js"
script.render = render

export default script